import styled from "styled-components";
import { margin } from "styled-system";

export const StyledVideoSection = styled.div`
  ${margin};
  position: relative;
  margin-bottom: -4px;
  
  & video {
    width: 100%;
  }
  
  & > button {
    position: absolute;
    cursor: pointer;
    display: flex;
    align-items: center;
    z-index: 1;
    top: 50%;
    left: 50%;
    background: none;
    font-weight: 600;
    font-size: 20px;
    color: #ffffff;
    transform: translate(-50%, -50%);
  }
  
  & > button > svg {
    margin-right: 8px;
  }
`;
